import React, { FC } from 'react';
import cn from 'classnames';
import Icon from '../Icon';
import style from './style.module.scss';

const CarBackButton: FC<any> = ({ history, path, className }) => {
  const goBack: any = () => {
    history.push(path);
  };

  return (
    <button
      className={cn(style.backLink, className)}
      type="button"
      onClick={goBack}
    >
      <Icon name="circled-angle" className={style.icon} />
      назад к списку
    </button>
  );
};

export default CarBackButton;
